import { render, staticRenderFns } from "./public-booking-request-cancel-modal.vue?vue&type=template&id=73315d30&scoped=true&"
import script from "./public-booking-request-cancel-modal.vue?vue&type=script&lang=ts&"
export * from "./public-booking-request-cancel-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73315d30",
  null
  
)

export default component.exports